import { Component, Input, OnInit, Inject } from '@angular/core';
import { StateService } from "@uirouter/core";
import { AppAlertService, ParametersService, PopupService, SubtitlesService } from "../core";
import { LanguageShortcut } from "../models";
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-policy',
  template: '',
  styleUrls: ['./policy.component.scss']
})
export class PolicyComponent implements OnInit {
  acceptPrivatePolicy = false;
  @Input() key: number;

  constructor(
      private $state: StateService,
      private subtitles: SubtitlesService,
      public popup: PopupService,
      private parameters: ParametersService,
      public appAlert: AppAlertService,
      @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    const mainWrapper = this.document.querySelector('.main-wrapper') as HTMLElement;
    mainWrapper.style.top = '0';
  }

  closePolicy(): void {
    this.popup.stopPopupInterval();
    this.popup.startPopupInterval();

    const mainWrapper = this.document.querySelector('.main-wrapper') as HTMLElement;
    mainWrapper.style.top = '60px';
    this.$state.go('home', { queryParams: { selectedModuleHash: this.parameters.selectedModuleHash } });
  }

  setSubtitle(element: number): string {
    return element ? this.subtitles.setSubtitle(element) : '';
  }

  scrollTo(hash: string): void {
    const element = this.document.getElementById(hash);
    if (element) element.scrollIntoView();
  }

  protected readonly LanguageShortcut = LanguageShortcut;
}